
/**
 * `TabsBuilder` - This is a component that helps to build types of tab components, such as Tabs and Division Switcher.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { TabsBuilderComponent } from './TabsBuilder';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';

export default (ComponentInitializeDispatcher as TabsBuilderComponent).extend({
  name: 'owc-tabs-builder',
  components: {
    SlotContainer,
  },
  props: {
    isDarkMode: {
      type: Boolean,
      default: false,
    },
    navigationDescription: {
      type: String,
      default: '',
    },
    isFullPageTabs: {
      type: Boolean,
      default: true,
    },
  },
});
